module.exports = __webpack_public_path__ + "static/img/reset_xiaoyuan.2b32831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/reset_xiaoyuan.png
// module id = 264
// module chunks = 1